import { constants } from '..';

const { EARLIEST_TIMESTAMP, LATEST_TIMESTAMP } = constants;

/**
 * Convert a TableStringFilterInput to a MaybeEmptyDateRange
 * @param filterInput - {@link TableStringFilterInput} or null
 * @returns a {@link MaybeEmptyDateRange} that is built from the filterInput
 */
export const filterInputToDateRange = (
    filterInput: Maybe<TableStringFilterInput | TableIntFilterInput>,
): MaybeEmptyDateRange => {
    const gt = filterInput?.gt ?? null;
    const lt = filterInput?.lt ?? null;
    const betweenStart = filterInput?.between?.[0] ?? null;
    const betweenEnd = filterInput?.between?.[1] ?? null;

    // To filter for a date range, we have to use the `between` field of a `TableStringFilterInput`,
    // so we check for that case first
    if (betweenStart !== null && betweenEnd !== null) {
        return {
            start: new Date(betweenStart),
            end: new Date(betweenEnd),
        };
    }

    // If there was not a full `between` value (consisting of two strings), check for `gt` first
    // and then `lt`
    if (gt !== null) {
        return {
            start: new Date(gt),
            end: new Date(LATEST_TIMESTAMP),
        };
    }

    if (lt !== null) {
        return {
            start: new Date(EARLIEST_TIMESTAMP),
            end: new Date(lt),
        };
    }

    return {
        start: null,
        end: null,
    };
};
